import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { StakingPools } from './StakingPools';
import { StakingHistory } from './StakingHistory';
import { RewardsCenter } from './RewardsCenter';
import { StakingStats } from './StakingStats';
import { useWallet } from '../wallet/WalletProvider';

export function StakingDashboard() {
  const { isConnected } = useWallet();
  const [activeTab, setActiveTab] = useState('pools');

  if (!isConnected) {
    return (
      <Card className="max-w-md mx-auto">
        <CardHeader>
          <CardTitle>Staking Dashboard</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-slate-600 dark:text-slate-400">
            Connect your wallet to start earning rewards through staking.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">Staking Dashboard</h1>
        <p className="text-slate-600 dark:text-slate-400 mt-2">
          Stake your NDH tokens and earn passive rewards
        </p>
      </div>

      {/* Staking Stats Overview */}
      <StakingStats />

      {/* Main Staking Interface */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="pools">Staking Pools</TabsTrigger>
          <TabsTrigger value="rewards">Rewards Center</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>

        <TabsContent value="pools" className="space-y-6">
          <StakingPools />
        </TabsContent>

        <TabsContent value="rewards" className="space-y-6">
          <RewardsCenter />
        </TabsContent>

        <TabsContent value="history" className="space-y-6">
          <StakingHistory />
        </TabsContent>
      </Tabs>
    </div>
  );
}